function reorderVariantOptions() {
  const variantPickers = document.querySelectorAll('variant-picker');
  
  variantPickers.forEach(variantPicker => {
    const form = variantPicker.querySelector('.variant-picker__form');
    if (!form) return;

    const fieldsets = Array.from(form.querySelectorAll('.variant-option'));
    if (fieldsets.length < 2) return; // No need to reorder if less than 2 options
    
    // Debug: Log current order
    fieldsets.forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend')?.textContent?.trim() || '';
    });
    
    // Ordenar fieldsets: Color primero, luego Size/Tamaño
    const sortedFieldsets = fieldsets.sort((a, b) => {
      const legendA = a.querySelector('legend')?.textContent?.trim().toLowerCase() || '';
      const legendB = b.querySelector('legend')?.textContent?.trim().toLowerCase() || '';
      
      // Color/Colour siempre va primero
      if (legendA.includes('color') || legendA.includes('colour')) return -1;
      if (legendB.includes('color') || legendB.includes('colour')) return 1;
      
      // Size/Tamaño/Talla va después
      if (legendA.includes('size') || legendA.includes('tamaño') || legendA.includes('talla')) return 1;
      if (legendB.includes('size') || legendB.includes('tamaño') || legendB.includes('talla')) return -1;
      
      return 0;
    });
    
    sortedFieldsets.forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend')?.textContent?.trim() || '';
    });

    // Solo reordenar si el orden actual es diferente
    let needsReorder = false;
    for (let i = 0; i < fieldsets.length; i++) {
      if (fieldsets[i] !== sortedFieldsets[i]) {
        needsReorder = true;
        break;
      }
    }

    if (needsReorder) {
      // Reorganizar el DOM
      sortedFieldsets.forEach(fieldset => {
        form.appendChild(fieldset);
      });
    }
  });
}

// Ejecutar al cargar la página
document.addEventListener('DOMContentLoaded', reorderVariantOptions);

// También ejecutar cuando se actualiza el contenido dinámicamente
document.addEventListener('product:updated', reorderVariantOptions);